import type { Reducer } from "@reduxjs/toolkit";
import type { NotificationActionTypes, Notification } from "../../src/store/notifications/types";

type MockState = {
    notifications: Notification[];
    outstandingRequestCount: number;
}

const initialState: MockState = {
    notifications: [],
    outstandingRequestCount: 0,
};

export const notificationsReducer: Reducer<MockState, any, MockState> = (state = initialState, action: NotificationActionTypes) => {
    switch (action.type) {
        case "ENQUEUE_SNACKBAR":
            return {
                ...state,
                notifications: [
                    ...state.notifications,
                    action.notification,
                ],
            };

        case "CLOSE_SNACKBAR":
            return {
                ...state,
                notifications: state.notifications.map(notification => (
                    (action.dismissAll || notification.key === action.key)
                        ? { ...notification, dismissed: true }
                        : { ...notification }
                )),
            };

        case "REMOVE_SNACKBAR":
            return {
                ...state,
                notifications: state.notifications.filter(
                    notification => notification.key !== action.key,
                ),
            };

        case "INCREMENT_OUTSTANDING_REQUEST_COUNT":
            return {
                ...state,
                outstandingRequestCount: state.outstandingRequestCount + 1
            };

        case "DECREMENT_OUTSTANDING_REQUEST_COUNT":
            return {
                ...state,
                outstandingRequestCount: Math.max(state.outstandingRequestCount - 1, 0)
            };

        default:
            return state;
    }
};